import { compose } from 'redux';

import { SeatMapRestrictions } from '@websky/graphql';
import { SeatMapGroup, SeatMapRowSeat } from '../model/types';

import { getIsSeatAvailableByCombineWith } from './getIsSeatAvailableByCombineWith';
import { getIsSeatAvailableByFilters } from './getIsSeatAvailableByFilters';

export function getRowsByGroupWithStates(
	groups: SeatMapGroup[],
	activeDoubleSeats: boolean,
	selectedFilters: Set<SeatMapRestrictions>
): SeatMapGroup[] {
	const seatAvailableCompose = compose<SeatMapRowSeat>(
		getIsSeatAvailableByCombineWith(activeDoubleSeats),
		getIsSeatAvailableByFilters(Array.from(selectedFilters || []))
	);

	return groups.map(group => ({
		...group,
		rows: group.rows.map(row => ({
			...row,
			seats: row.seats.map(seatAvailableCompose)
		}))
	}));
}
